export const comments_3278338 = {"data":{"data":[],"links":{}}}